var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestimonialConfirm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#27D639"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 35.4824V41.6664C18.667 42.0984 18.9443 42.4811 19.355 42.6171C19.4577 42.6504 19.563 42.6664 19.667 42.6664C19.979 42.6664 20.2803 42.5197 20.4723 42.2584L24.0896 37.3358L18.667 35.4824Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.58 12.1855C38.2733 11.9681 37.8706 11.9388 37.5373 12.1135L7.53739 27.7801C7.18273 27.9654 6.97339 28.3441 7.00273 28.7427C7.03339 29.1427 7.29873 29.4841 7.67606 29.6134L16.016 32.4641L33.7773 17.2774L20.0333 33.836L34.0106 38.6134C34.1146 38.648 34.224 38.6667 34.3333 38.6667C34.5146 38.6667 34.6946 38.6174 34.8533 38.5214C35.1066 38.3667 35.2786 38.1067 35.3226 37.8147L38.9893 13.1481C39.044 12.7748 38.8866 12.4041 38.58 12.1855Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialConfirm);
export default __webpack_public_path__ + "static/media/testimonialConfirm.ec59ac2deecab919a7f4890f738539b2.svg";
export { ForwardRef as ReactComponent };